// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__9bQ7y","content":"RecentSearches_content__2iCT6"};